import { useState } from 'react';

import FileSaver from 'file-saver';

import { useHandleBackErrors } from 'hooks/utils/handleBackErrors';
import { RequestStatus } from 'types/RequestStatus';
import { extractFileNameFromContentDisposition } from 'utils/requestUtils';

interface ExportFileResult {
  downloadStatus: RequestStatus | undefined;
  download: () => Promise<void>;
}

/**
 * Hook to import any referentiel in CSV or JSOn format
 */
function useExportFile(
  downloadFile: () => Promise<Response>,
): ExportFileResult {
  const behaviourOnError = useHandleBackErrors();
  const [requestStatus, setStatus] = useState<RequestStatus>();

  const download = async () => {
    setStatus(RequestStatus.PENDING);
    let fileName: string | undefined = undefined;

    await downloadFile()
      .then((result: Response) => {
        fileName = extractFileNameFromContentDisposition(result);
        // Create dom link to download file
        return result.blob();
      })
      .then((blob: Blob) => {
        FileSaver.saveAs(blob, fileName);
        setStatus(RequestStatus.SUCCESS);
      })
      .catch((errorResponse: Response) => {
        setStatus(RequestStatus.ERROR);
        behaviourOnError(errorResponse, true);
      });
  };
  return {
    downloadStatus: requestStatus,
    download: download,
  };
}

export default useExportFile;
